import { Injectable, EventEmitter, Output } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { AutenticacionService } from './autenticacion.service';
import { ConstantsService } from './constants.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';

export interface InversionPayload {
  inversionista_id?: number;
  promotor_id?: number;
  sociedad_id?: number;
  saldoInicial: number;
  tasaInteres: number;
  tasaRetencion: number;
  diasAnoFiscal: number;
  diasPeriodo: number;
  fechaInicio: string;
  fechaFin: string;
  vidaPagare?: string;
  desglose?: any[];
}

@Injectable()
export class InversionesService {
  @Output() enviaBandera: EventEmitter<any> = new EventEmitter();
  private service_url: string;

  constructor(
    private constantsService: ConstantsService, 
    private http: Http,
    private authService: AutenticacionService, 
    private validatorService: ValidatorService, 
    private errorService: ErrorsService
  ) { 
    this.service_url = this.constantsService.apiURL + '/inversionistas';
  }

  // POST para calcular la tabla/desglose proyectado en memoria
  public calcular(data: InversionPayload) {
    return this.http.post(
      `${this.service_url}/calcular`, 
      data, 
      this.authService.getAuthHeaders()
    );
  }

  // POST para guardar definitivamente en la BD
  public create(data: InversionPayload) {
    return this.http.post(
      `${this.service_url}/crearinversion`, 
      data, 
      this.authService.getAuthHeaders()
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/services/inversiones.service.ts